import { render, staticRenderFns } from "./employee.vue?vue&type=template&id=17aee1a4"
import script from "./employee.vue?vue&type=script&lang=js"
export * from "./employee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Svanehoj-v-13.Website\\src\\Webpack\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17aee1a4')) {
      api.createRecord('17aee1a4', component.options)
    } else {
      api.reload('17aee1a4', component.options)
    }
    module.hot.accept("./employee.vue?vue&type=template&id=17aee1a4", function () {
      api.rerender('17aee1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/vue/components/employee.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/scripts/vue/components/employee.vue
// module id = 38
// module chunks = 0